import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { GetPartnershipEffects } from './effects';
import { featureKey, reducer } from './reducer';
import { GetPartnershipService } from './service';

@NgModule({
  imports: [EffectsModule.forFeature([GetPartnershipEffects]), StoreModule.forFeature(featureKey, reducer)],
  providers: [GetPartnershipService],
})
export class GetPartnershipModule {}
